import * as React from 'react';

import {
  BonusIcon,
  DiscountIcon,
  MortgageIcon,
  MaternalCapitalIcon,
  MilitaryMortgageIcon,
} from '../../../../components/PromosPreview/icons';
import { TPromoType } from '../../../../types/specialPromos/specialPromos';

interface IPromoIconContainer {
  type: TPromoType;
}

/* istanbul ignore next */
export const PromoIconContainer = ({ type }: IPromoIconContainer) => {
  switch (type) {
    case 'bank':
    case 'mortgage':
      return <MortgageIcon />;

    case 'bonus':
      return <BonusIcon />;

    case 'discount':
      return <DiscountIcon />;

    case 'maternalCapital':
      return <MaternalCapitalIcon />;

    case 'militaryMortgage':
      return <MilitaryMortgageIcon />;

    default:
      return null;
  }
};
